import { render, staticRenderFns } from "./AdminCreateFleet.vue?vue&type=template&id=023d8ac2&scoped=true"
import script from "./AdminCreateFleet.vue?vue&type=script&lang=js"
export * from "./AdminCreateFleet.vue?vue&type=script&lang=js"
import style0 from "./AdminCreateFleet.vue?vue&type=style&index=0&id=023d8ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d8ac2",
  null
  
)

export default component.exports